import { deriveStatus, TONE_CLASSES } from "@/utils/intelligence";

/**
 * FIDS StatusBadge — communicates the intelligence status of an opportunity
 * (High Potential, Emerging, Validated, Watchlist, High Risk).
 *
 * Renders solid or soft variants and always includes a semantic colour dot
 * for scan-ability across the interface.
 */
export const StatusBadge = ({
  opportunity,
  meta,
  variant = "soft",
  size = "md",
  testId,
}) => {
  const status = deriveStatus(opportunity, meta);
  const classes = TONE_CLASSES[status.tone] ?? TONE_CLASSES.intel;

  const sizeClasses =
    size === "sm"
      ? "px-2 py-0.5 text-[10px]"
      : size === "lg"
        ? "px-3 py-1.5 text-sm"
        : "px-2.5 py-1 text-xs";

  const surface = variant === "solid" ? classes.solid : classes.soft;

  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border font-medium tracking-tight ${surface} ${sizeClasses}`}
      title={status.description}
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${classes.dot}`}
        aria-hidden
      />
      {status.label}
    </span>
  );
};
